import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "../../../config/authAxios";

const initialState = {
  status: null,
  loading: false,
  data: [],
  error: "",
  message: "",
};

export const getSingleChallengeAction = createAsyncThunk(
  "get-single-challenge",
  async (data = null, { rejectWithValue }) => {
    try {
      console.log("datt===================>",data)
      const res = await axios.get(
        `/admins/api/challenge/${data?.challenge_id}`
      );
      return res?.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

export const getSingleChallengeSlice = createSlice({
  name: "get-single-challenge",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getSingleChallengeAction.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getSingleChallengeAction.fulfilled, (state, action) => {
      state.loading = false;
      state.data = action?.payload?.data;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
    builder.addCase(getSingleChallengeAction.rejected, (state, action) => {
      state.loading = false;
      state.error = action?.payload?.error;
      state.status = action?.payload?.status;
      state.message = action?.payload?.message;
    });
  },
});

export const getSinglechallengeReducer = getSingleChallengeSlice.reducer;
